<template>
  <div class="slideNav">
    <div class="slideNav__leftArrow">
      <a href="#" @click.prevent="scroll_list(-1)">
        <img src="@/assets/icon/main_menu_arrow_left.png" alt="">
      </a>
    </div>
    <ul class="slideNav__list"
    @mouseenter="bind_scroll"
    @mouseleave="unbind_scroll">
      <li class="slideNav__list__item"
      v-for="(item, index) in data"
      :key="index">
        <a href="#" class="slideNav__list__a"
        @click="go_page(item.route)">
          <span class="slideNav__list__chinese">
            {{item.chinese}}
          </span>
          <span class="slideNav__list__english">
            {{item.english}}
          </span>
        </a>
      </li>
    </ul>
    <div class="slideNav__rightArrow">
      <a href="#" @click.prevent="scroll_list(1)">
        <img src="@/assets/icon/main_menu_arrow.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: ['parent', 'data'],
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    toggle_arrow() {
      const list = $(`.${this.parent} .slideNav__list`);
      const listItems = $(`.${this.parent} .slideNav__list__item`);
      const leftArrow = $(`.${this.parent} .slideNav__leftArrow`);
      const rightArrow = $(`.${this.parent} .slideNav__rightArrow`);

      let listItemsWidthSum = 0;
      [...listItems].forEach((item) => {
        listItemsWidthSum += Math.floor($(item).outerWidth());
      });

      if (list.outerWidth() < listItemsWidthSum) {
        if (list.scrollLeft() !== 0) {
          leftArrow.fadeIn();
        } else {
          leftArrow.fadeOut();
        }
        if (list.scrollLeft() + list.outerWidth() < listItemsWidthSum) {
          rightArrow.fadeIn();
        } else {
          rightArrow.fadeOut();
        }
      } else {
        leftArrow.fadeOut();
        rightArrow.fadeOut();
      }
    },
    bind_scroll() {
      $(window).bind('mousewheel', (e) => {
        this.scroll_list(e.originalEvent.deltaY);
      });
    },
    unbind_scroll() {
      $(window).unbind('mousewheel');
    },
    scroll_list(deltaY) {
      const list = $(`.${this.parent} .slideNav__list`);
      if (deltaY > 0) {
        list.animate({
          scrollLeft: '+=40',
        }, 'fast', () => {
          this.toggle_arrow();
        });
      } else {
        list.animate({
          scrollLeft: '-=40',
        }, 'fast', () => {
          this.toggle_arrow();
        });
      }
    },
  },
  mounted() {
    const parent = $(`.${this.parent}`);
    const list = $(`.${this.parent} .slideNav__list`);
    const listItems = $(`.${this.parent} .slideNav__list__item`);

    [...listItems].forEach((item) => {
      $(item).height(parent.height());
    });
    this.toggle_arrow();
    $(window).resize(() => {
      this.toggle_arrow();
    });

    list.animate({
      left: '18px',
      opacity: '1',
    }, 'slow');
  },
};
</script>
